import {getCookie, setCookie} from '../global/cookie';


// eslint-disable-next-line no-undef
const is_show_leads_form_popup = global_params.show_leads_form_popup;

const set_display_popup = (element, trigger_in_milisecond) => {

    let is_show_leads_form_popup_cookie = getCookie('show_leads_form_popup_widget');

    if( (is_show_leads_form_popup_cookie == '') && (is_show_leads_form_popup == true) ) {

        setTimeout(function() { //fire
            document.querySelector(element).click();
            setCookie('show_leads_form_popup_widget', 1, 3, false);
        }, trigger_in_milisecond);

    }
}

document.addEventListener('DOMContentLoaded', () => {
    set_display_popup('body > div.wa__btn_popup > button', 1000);
});


// WEBPACK FOOTER //
// ./scripts/global/popup.js